import React from 'react';
import { connect } from 'react-redux';
import { IDataStorage, Translate } from '../../core';
import { FxTranslate } from '../../core/translate';
import Common from '../../services/common';
import Security from '../../services/seguridad';
import { IMenu } from '../../services/seguridad/model';
import styles from './index.module.scss';
import * as Service from './service';

const DictionaryKey = 'Menu';

export interface IMenuLayoult extends IMenu {
  selected?: boolean;
  open?: boolean;
}

interface IProps {
  storage?: IDataStorage;

  opened?: boolean;
  onToogleOpen: () => void;
}

interface IState {
  storage?: IDataStorage;

  opened?: boolean;

  menu?: IMenuLayoult[];
}

class Index extends React.Component<IProps, IState> {
  state : IState = { }
  
  componentDidMount = () => {
    Index.getDerivedStateFromProps(this.props, this.state);
    // cargar los favoritos y el historial del usuario
    const menu = Security.GetMenu(false);

    const actives = Service.searchPath(window.location.pathname, menu);
    actives.forEach(act => {
      act.open = true;
      act.selected = true;
    });

    // chequeo de cambio de historial
    const { storage } = this.state;
    let historial = Service.getHistorial(storage?.user?.id);
    const menumenu = Service.searchPath(window.location.pathname, menu ?? []).pop();
    if (menumenu?.url && !historial.includes(menumenu.url))
      Service.AddHistorial(menumenu.url, storage?.user?.id);

    this.setState({ menu });
  }
  static getDerivedStateFromProps = (p : IProps, s : IState) : IState => {
    let res : IState = { };
    if (p?.storage !== s?.storage) res.storage = p.storage;
    if (p?.opened !== s?.opened) res.opened = p.opened;
    return res;
  }

  switchFav = (menu: IMenuLayoult) => {
    const { storage } = this.state;
    Service.swithFavorito(storage?.user?.id, menu.url);
    this.setState({ menu: (this.state.menu ?? []).slice(0) })
  }

  builder = (menus: IMenuLayoult[], t: FxTranslate, favoritos?: string[], opened?: boolean) : JSX.Element[] => {
    const elements : JSX.Element[] = [];
    menus.forEach(menu => {
      const subitems = menu.menus?.length ?? 0;
      //const selected = window.location.pathname.startsWith(menu.url ?? '!');

      // títulos
      if (!!menu.title && subitems > 0) {
        const icon = !!menu.open ? "fas fa-chevron-right" : "fas fa-chevron-down";

        if (!!opened) {
          elements.push(
            this.buildMenuFolder(
              icon, menu.icon, t(menu.name), menu.selected, () => {
                const newState = !menu.open;
                menus.forEach(m2 => m2.open = false);
                menu.open = newState;
                this.setState({ menu: menus.slice(0) })
              }
            )
          )
        } else {
          elements.push(this.buildMenuCollapsed(menu.icon))
        }
        if (menu.open && !!opened)
          elements.push(...this.builder(menu.menus ?? [], t, favoritos, opened))
      } else if (!menu.title && !!opened) {  // menús hojas
        elements.push(
          this.buildMenu(t(menu.name), menu.selected, favoritos?.includes(menu.url ?? ''), () => Common.url.redirect(menu.url ?? ''), () => this.switchFav(menu))
        )
      }
    })
    return elements;
  }

  render() {
    const { storage, opened, menu } = this.state;
    const t = Translate.get(DictionaryKey, storage?.languaje);

    const favoritos = Service.getFavoritos(storage?.user?.id);
    const historial = Service.getHistorial(storage?.user?.id);

    const elements : JSX.Element[] = [];
    if (opened) {
      elements.push(this.buildMenuFolder(undefined, "fas fa-bars", t("Menu.Title"), false, () => this.props.onToogleOpen()))
      elements.push(this.buildMenuFolder(undefined, "fas fa-home", t("Home.Title"), false, () => Common.url.redirect("/")))
      elements.push(this.buildMenuFolder(undefined, "fab fa-flipboard", t("Board"), false, () => Common.url.redirect("/admin/board")))
    } else {
      elements.push(this.buildMenuCollapsed("fas fa-bars"));
      elements.push(this.buildMenuCollapsed("fas fa-home"));
      elements.push(this.buildMenuCollapsed("fab fa-flipboard"));
    }

    // elementos de menu standard
    elements.push(...this.builder(menu ?? [], t, favoritos, opened));

    elements.push(this.buildMenuFolder(undefined, "fas fa-question-circle", t("Sistema.Faqs"), false, () => Common.url.redirect("/admin/config/instructivo")))

    // aplico favoritos
    if (!!opened && (favoritos?.length ?? 0) > 0) {
      elements.push(this.buildSeparator());
      elements.push(this.buildMenuTitle("far fa-heart", t("Favoritos.Title")));
      favoritos!.forEach(fav => {
        const m = Service.searchPath(fav, menu ?? []).pop();
        if (m)
        elements.push(this.buildMenu(t(m.name), m.selected, favoritos?.includes(m.url ?? ''), () => Common.url.redirect(m.url ?? ''), () => this.switchFav(m)));
      })
    }

    // aplico historial
    if (!!opened && (historial?.length ?? 0) > 0) {
      elements.push(this.buildSeparator());
      elements.push(this.buildMenuTitle("fas fa-history", t("Historico.Title")));
      historial!.forEach(his => {
        const m = Service.searchPath(his, menu ?? []).pop();
        if (m)
        elements.push(this.buildMenu(t(m.name), m.selected, favoritos?.includes(m.url ?? ''), () => Common.url.redirect(m.url ?? ''), () => this.switchFav(m)));
      })
    }

    return <div className={styles["container-menu"]}>
      {elements}

      {/*buildMenuFolder(undefined, "fas fa-bars", t("Menu.Title"), undefined, () => this.props.onToogleOpen())}
      {buildMenuFolder(undefined, "fas fa-home", t("Home.Title"))}
      {buildMenuFolder("fas fa-chevron-down", "fas fa-fire", t("Menu.Cliente"))}
      {buildMenu(undefined, undefined, t("Menu.Cliente"))}
      {buildMenu(undefined, undefined, t("Menu.Cotizadores"), true)}
      {buildMenu("fas fa-chevron-right", "fas fa-user", t("Seguridad.Cliente"), false, true)}
      {buildMenu("fas fa-chevron-right", "fas fa-phone", t("Cintactos.Cliente"))}
      {buildSeparator()}
      {buildMenuTitle("far fa-heart", t("Favoritos.Title"))}
      {buildMenu(undefined, undefined, t("Menu.Cliente"), false, true)}
      {buildMenu(undefined, undefined, t("Menu.Cotizadores"), true, true)}
      {buildSeparator()}
      {buildMenuTitle("fas fa-history", t("Recientes.Title"))}
      {buildMenu(undefined, undefined, t("Menu.Cliente"))}
      {buildMenu(undefined, undefined, t("Menu.Cotizadores"), true)}
      {/*buildMenu("fas fa-home", t("Home.Title"), 0, !!opened)}
      {buildMenu("fas fa-mug-hot", t("Clientes.Title"), 0, !!opened, true)}
      {buildMenu("fas fa-fire", t("Menu.Clientes"), 0, !!opened, undefined)}
      {buildMenu("fas fa-user", t("Menu.Cotizadores"), 0, !!opened, undefined)*/}
    </div>;
  }
  
  buildMenuCollapsed = (icon?: string) => {
    return <div className={styles["menu-item"]} onClick={() => this.props.onToogleOpen()}>
      <i className={`${styles["menu-title-icon"]} ${icon}`}></i>
    </div>
  }

  buildMenuTitle = (icon?: string, text?: string) => {
    return <div className={styles["menu-item"]}>
      <i className={`${styles["menu-title-icon"]} ${icon}`}></i>
      <div className={styles["menu-title-text"]}>{text}</div>
    </div>
  }

  buildMenuFolder = (icon1?: string, icon2?: string, text?: string, selected?: boolean, click?: () => void) => {
    return <div className={`${styles["menu-item"]} ${selected ? styles["menu-item-selected"] : ''}`} onClick={click}>
      <i className={`${styles["menu-item-icon1"]} ${icon1}`}></i>
      <i className={`${styles["menu-item-icon2"]} ${icon2}`}></i>
      <div className={styles["menu-item-text"]}>{text}</div>
    </div>
  }

  buildMenu = (text?: string, selected?: boolean, favorito?: boolean, click?: () => void, switchFav?: () => void) => {
    return <div className={`${styles["menu-item"]} ${selected ? styles["menu-item-selected"] : ''}`}  style={{ display: 'flex', alignItems: 'center' }}>
      <div onClick={click} style={{ width: '100%', height: '100%' }}>
        <div className={styles["menu-item-text"]} style={{ paddingLeft: 50 }}>{text}</div>
      </div>
      <i 
        className={`${styles["menu-item-favorito"]} ${!favorito ? 'far fa-heart' : 'fas fa-heart'}`} 
        style={{ visibility: favorito ? 'visible' : undefined }} 
        onClick={() => switchFav && switchFav() }
      />
    </div>
  }

  buildSeparator = () => {
    return <div className={`${styles["separator"]}`} />
  }
}


/*
function buildMenu2(icon: string, text: string, tab: number, opened: boolean, folderIconOpen?: boolean) {
  const folderIconClass = folderIconOpen === undefined ? '' : (folderIconOpen === true ? 'fas fa-chevron-down' : 'fas fa-chevron-right');
  return <div className={styles["menu-item"]}>
    <i className={`${styles["folder-icon"]} ${folderIconClass}`}></i>
    <i className={`${styles["menu-item-icon"]} ${icon}`}></i>
    <div className={styles["menu-item-text"]}>{text}</div>
  </div>
}
*/


export default connect((s:any) => ({ storage:s.main }))(Index);